import {storeController} from "./store";
import {markerController} from "./marker";
import {Store, Map} from "./models";

class Position {

  // =========================
  // 🔹 GET USER POSITION
  // =========================

  async getPos(
    geolocationEnabled: Function,
    geolocationDisabled: Function
  ) {
    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position: GeolocationPosition) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        return geolocationEnabled(pos);
      }
    );

    return geolocationDisabled();
  }

  // =========================
  // 🔹 HANDLE ENABLED GEOLOCATION
  // =========================

  geolocationEnabled(
    pos: google.maps.LatLng,
    stores: Store[],
    map?: google.maps.Map
  ) {
    const updatedStores = storeController.updateStoreDistance(stores, pos);
    const closestStores = storeController.getClosestStores(3, updatedStores);
    const bounds = storeController.createBoundsForClosestStore(closestStores[0], pos);
    const positionMarker = markerController.createPositionMarker(pos, map);

    return new Map({
      updatedStores,
      closestStores,
      positionMarker,
      bounds,
      pos,
      map
    });
  }

  // =========================
  // 🔹 HANDLE DISABLED GEOLOCATION
  // =========================

  geolocationDisabled(
    stores: Store[],
    countryCode: string
  ) {
    const bounds = new google.maps.LatLngBounds();
    const countryCodeStores = stores.filter(store =>
      store.countryCode.toLowerCase() === countryCode
    );
    countryCodeStores.forEach((store: Store) => bounds.extend(store));
    return bounds;
  }

  // =========================
  // 🔹 ZOOM ADJUSTMENT
  // =========================

  extendZoom(map: Map) {
    const bounds = new google.maps.LatLngBounds();
    let zoomLevel = 15;

    const zoomInterval = setInterval(() => {
      bounds.extend(map.closestStores[0]);
      map.map?.setZoom(zoomLevel);

      if (
        map.map?.getBounds()?.contains(map.closestStores[0].marker.position as google.maps.LatLng)
      ) {
        clearInterval(zoomInterval);
      } else {
        zoomLevel--;
      }
    }, 200);
  }
}

export const position = new Position();
